const Brandfolder = BF.fx.brandfolder();
const Collection = BF.fx.collection();
const Resource = BF.fx.resource();

const bulkRefreshSections = (selectedAssetKeys, delay, extraSectionKeysArray) => {
  const selectedSections = extraSectionKeysArray || []; // extraSectionKeys (Array) necessary for BulkMove - need to refresh section where assets are being moved, but won't have selected asset

  selectedAssetKeys.forEach((asset) => {
    const assetElement = document.getElementById(asset);

    if (assetElement) {
      const section = assetElement.dataset.section;

      if (selectedSections.indexOf(section) < 0) {
        selectedSections.push(section);
      }
    }
  });

  if (selectedSections.length) {
    if (typeof delay === 'number' && delay > 0) {
      setTimeout(() => {
        selectedSections.forEach((section) => {
          BF.fx.dispatchWindowEvent('refreshSection', section);
        });
      }, delay);
    } else {
      selectedSections.forEach((section) => {
        BF.fx.dispatchWindowEvent('refreshSection', section);
      });
    }
  }
};

const pluralizeObject = (itemArray) => {
  const qty = itemArray instanceof Set ? itemArray.size : itemArray.length;
  const plural = qty === 1 ? '' : 's';

  return { qty, plural };
};

export {
  Brandfolder,
  Collection,
  Resource,
  bulkRefreshSections,
  pluralizeObject,
};
